import { getPublicKey } from "./getPublicKey";
import { signTransaction } from "./signTransaction";
import { isConnected } from "./isConnected";
import { getNetwork } from "./getNetwork";
import { getNetworkDetails } from "./getNetworkDetails";

export {
  getPublicKey,
  signTransaction,
  isConnected,
  getNetwork,
  getNetworkDetails,
};
export default {
  getPublicKey,
  signTransaction,
  isConnected,
  getNetwork,
  getNetworkDetails,
};
